const setSecondChildrenCountry = (id = null, val = null) => {
  return {
    type: 'SET_SECONDCHILDRENCOUNTRY',
    id,
    data: val,
  }
}

export default {
  setSecondChildrenCountry,
}